import { render, staticRenderFns } from "./UserViewedReports.vue?vue&type=template&id=53798a27&scoped=true"
import script from "./UserViewedReports.vue?vue&type=script&lang=js"
export * from "./UserViewedReports.vue?vue&type=script&lang=js"
import style0 from "./UserViewedReports.vue?vue&type=style&index=0&id=53798a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53798a27",
  null
  
)

export default component.exports